import { ROOT_URL } from 'gatsby-env-variables'
import { useContext } from 'react'
import { navigate } from 'gatsby'
import ROUTES from 'Routes'
import If from '@mobi/components/If'
import Text from 'components/Text'
import ItauBusinessBanner from 'components/ItauBusinessBanner'
import { ThemeContext } from 'modules/Theme'
import backToHomeRedirect from 'utils/backToHomeRedirect'
import analytics from '@mobi/libraries/analytics'
import RecoveryLogo from '/static/icons/logo-recovery.svg'
import ItauLogo from '/static/icons/logo-itau.svg'
import './Header.scss'

const handleLogoTracking = (ev) => {
  const element = ev?.currentTarget

  analytics.track('elementClicked', {
    location: element.dataset.trackingLocation,
    position: element.dataset.trackingPosition,
    elementType: element.dataset.trackingElement,
    text: element.ariaLabel,
    htmlId: element.dataset.unique,
    actionOutcome: element.dataset.trackingActionoutcome,
    outboundUrl: element.dataset.trackingOutboundurl,
  })

  analytics.track('segmentButtonClick', {
    name: 'HeaderLogo',
    id: element.dataset.unique,
  })
}

const Header = () => {
  const { theme } = useContext(ThemeContext)

  const isRecoveryOrigin = theme === 'recovery'
  const isItauOrigin = theme === 'reneg'
  const toUrl = backToHomeRedirect()

  return (
    <>
      <header className={`header ${theme}`}>
        <div
          className="logo"
          data-unique="da59bad1-4dfa-4556-a5da-fe7b3919fe0d"
          id="logo-header"
          role="button"
          data-tracking-location="header"
          data-tracking-position="header-menu"
          data-tracking-actionoutcome="redirect"
          data-tracking-element="link"
          aria-label="Logo"
          data-tracking-outboundurl={`${ROOT_URL}${ROUTES.register.path}`}
          onClick={(ev) => {
            navigate(toUrl)
            handleLogoTracking(ev)
          }}
        >
          <If
            condition={isItauOrigin}
            renderIf={
              <ItauLogo
                alt="Logo Itaú"
                width={38}
                height={38}
                className="logo-itau"
              />
            }
            renderElse={
              <RecoveryLogo
                alt="Logo oficial da Recovery"
                width={100}
                height={19}
              />
            }
          />
        </div>
        <If
          condition={isRecoveryOrigin}
          renderIf={
            <div className="header__container-itau">
              <div
                className="banner-itau"
                aria-label="Uma empresa Itaú"
                role="img"
              >
                <Text p aria-hidden="true" size={5}>
                  Uma empresa
                </Text>
                <ItauLogo
                  width={25}
                  height={32}
                  alt="logo Itaú"
                  aria-hidden="true"
                />
              </div>
            </div>
          }
        />
      </header>
      <If condition={isItauOrigin} renderIf={<ItauBusinessBanner />} />
    </>
  )
}

export default Header
